import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FloatLabelModule } from 'primeng/floatlabel';
import { SelectModule } from 'primeng/select';

import { FloatLabelVariant } from '../ui-types';
import { createGuid } from '../../utils/guid';

@Component({
  selector: 'select-input-field',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, FloatLabelModule, SelectModule],
  templateUrl: './select-input-field.component.html',
  styleUrl: './select-input-field.component.scss',
})
export class SelectInputFieldComponent implements OnInit {
  @Input() label = '';
  @Input() options: { id: string; displayValue: string }[] = [];
  @Input({ required: true }) control!: FormControl;
  @Input() variant?: FloatLabelVariant = 'in';
  @Input() prefixIcon?: string;
  @Input() suffixIcon?: string;
  @Input() errorMessage?: string;
  @Output() changed = new EventEmitter<string>();

  id?: string = createGuid('input_field');

  ngOnInit(): void {
    if (this.hasLabel()) {
      this.id = createGuid('select_input_field');
      return;
    }
    this.variant = 'over';
  }

  hasLabel(): boolean {
    return !!this.label && this.label.length > 0;
  }

  showClear(): boolean {
    return !!this.control && !!this.control.value;
  }
}
